import { Button, Modal } from '@wework/dieter-ui'
import Row from '../Common/Row'
import React from 'react'

export default function FirstTimeModal({ open, onClose }) {
  return (
    <Modal
      style={{ width: 420, padding: 16 }}
      onClose={onClose}
      // onOpen={() => handler(true)}
      open={open}
    >
      <Modal.Header style={{ padding: 0 }}>
        <Row>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span
              style={{
                width: 'fit-content',
                backgroundColor: '#E5FFFD',
                color: '#00665D',
                fontSize: 12,
              }}
            >
              New
            </span>
            Inventory Manager
          </div>
          <Button basic onClick={onClose} icon="close" style={{}} />
        </Row>
      </Modal.Header>
      <Modal.Content>
        <span>
          Inventory Manager is an evolution of Occupancy Map. It includes
          similar base functionality with new visuals and added capabilities
          like editing to keep your space up to date.
          <br />
          Jump in right away or read more about what's changed and access the
          user guide/FAQ on Connect.
        </span>
      </Modal.Content>
      <Modal.Actions style={{ textAlign: 'left' }}>
        <Button style={{ marginLeft: 0 }} onClick={onClose} primary>
          Get started
        </Button>
        <Button
          basic
          as="a"
          target="_blank"
          href="https://connect.weworkers.io/display/WWKB/Inventory+Manager+User+Guide"
          primary
          // disabled={submittingNote}
          // loading={submittingNote}
        >
          Read more on connect
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
